module.exports = __webpack_public_path__ + "img/reset-un.c338f8e5.png";